import { hasNoElements } from "./Array";
import { isNumber } from "./Number";
import { isNullOrWhiteSpace, isString } from "./String";

export function isNullish(value: unknown): boolean {
  if (value == null) {
    return true;
  }

  if (isNumber(value) && value === 0) {
    return true;
  }

  if (isString(value) && isNullOrWhiteSpace(value)) {
    return true;
  }

  if (Array.isArray(value) && hasNoElements(value)) {
    return true;
  }

  return false;
}
